import { render } from "./User_Activities.vue?vue&type=template&id=60238d3e"
import script from "./User_Activities.vue?vue&type=script&lang=js"
export * from "./User_Activities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__